// O botao de baixar o app na Google Play.
//
// Portado do 38 Brasil, com a identidade do 82 (o laranja no lugar do verde).
// A mecanica e a mesma, e cada parte dela existe por um motivo -- estao todos
// comentados abaixo, porque sao exatamente as coisas que alguem "limpa" depois
// e traz o problema de volta.

import React from 'react';
import { marcar } from './analytics.js';

/** ⚠️ O MESMO id do `applicationId` do app. Errar aqui leva para uma pagina
    que nao existe, e ninguem percebe ate um usuario reclamar. */
export const PACOTE = 'com.clubegreen.basquete82';

const URL_PLAY = `https://play.google.com/store/apps/details?id=${PACOTE}`;
/* O `market://` abre o aplicativo da Play direto, sem passar pelo navegador.
   So funciona em Android com a loja instalada -- por isso ele e uma TENTATIVA,
   com queda para o https. */
const URL_LOJA_NATIVA = `market://details?id=${PACOTE}`;

/**
 * O botao aparece?
 *
 * ⚠️ LIGADO EM 05/09/2026 COM A FICHA AINDA EM ANALISE, por decisao do dono:
 * a publicacao esta prestes a sair e nao vale um segundo deploy so para
 * acender o botao. Ate a ficha entrar no ar,
 * `play.google.com/store/apps/details?id=com.clubegreen.basquete82` responde
 * 404 -- quem clicar cai em "item nao encontrado".
 *
 * Se a analise demorar ou for reprovada, DESLIGUE: botao que leva a lugar
 * nenhum faz o visitante concluir que o jogo foi abandonado, e isso custa mais
 * caro do que a instalacao que ele traria.
 *
 * Para conferir se ja esta no ar:
 *   curl -s -o /dev/null -w "%{http_code}"  *     "https://play.google.com/store/apps/details?id=com.clubegreen.basquete82"
 * 200 = publicada. 404 = ainda nao.
 */
export const APP_NA_PLAY = true;

/**
 * A pessoa ja esta DENTRO do app? So responde SIM quando tem certeza.
 *
 * Dois sinais, os dois explicitos:
 *
 *   1. a classe `is-native-app` no <html>, se a casca puser
 *   2. `?nativeApp=1` no endereco -- e o que o 38 Brasil usa, e o que o
 *      MainActivity do 82 manda a partir da versao seguinte a 1.2.0
 *
 * ============================================================================
 * ⚠️ AQUI TINHA UM TERCEIRO SINAL, E ELE FOI TIRADO EM 07/09/2026.
 *
 * Era `/\bwv\b/` no user agent, que a WebView do Android sempre manda. A
 * intencao era boa -- o app 1.2.0 que esta na loja nao manda os dois sinais
 * de cima, e sem o terceiro quem ja instalou via "baixe o app" dentro do
 * proprio app.
 *
 * O problema e que `wv` nao identifica o NOSSO app: identifica QUALQUER
 * WebView do Android. O navegador embutido do WhatsApp, do Instagram e do
 * Facebook tambem e WebView -- e e exatamente ali que caem os links que as
 * pessoas compartilham. Ou seja: o sinal escondia o botao de instalar
 * justamente de quem tinha acabado de receber a indicacao de um amigo, que e
 * o publico mais propenso a instalar que existe.
 *
 * O dono viu o botao sumido e reclamou. Ele estava certo.
 *
 * A troca agora e outra: sem o `wv`, quem esta dentro do app 1.2.0 ve um
 * botao de baixar o que ja tem. Custa um toque, e a Play responde "Abrir".
 * Isso e MUITO mais barato que perder a instalacao de quem veio do WhatsApp.
 * E some sozinho na proxima versao do app, que ja manda `?nativeApp=1`.
 * ============================================================================
 */
export function dentroDoApp() {
  try {
    if (document.documentElement.classList.contains('is-native-app')) return true;
    return new URLSearchParams(window.location.search).get('nativeApp') === '1';
  } catch {
    return false;
  }
}

const ehAndroid = () => {
  try { return /Android/i.test(navigator.userAgent || ''); } catch { return false; }
};

/**
 * O clique.
 *
 * No computador nao faz nada de especial: o <a> abre a Play no navegador, e
 * pronto. No Android tenta abrir o APLICATIVO da Play (`market://`), que e
 * bem mais rapido e ja cai na tela de instalar.
 *
 * ⚠️ A queda para o https e por TEMPO, e nao por erro: navegador nao avisa que
 * um `market://` falhou. Entao marcamos 1,2 s e, se a pagina continuar em foco
 * (ou seja, a loja NAO abriu), abrimos o endereco normal. Se a loja abriu, os
 * eventos de sair da pagina cancelam o relogio -- sem isso a pessoa volta da
 * Play e encontra uma aba extra aberta.
 */
function aoClicar(evento) {
  marcar('play_store_clique', { pacote: PACOTE });
  if (typeof window === 'undefined' || !ehAndroid()) return;
  evento?.preventDefault?.();

  let caiu = false;
  const abrirNoNavegador = () => {
    if (caiu) return;
    caiu = true;
    if (!window.open(URL_PLAY, '_blank', 'noopener,noreferrer')) {
      try { window.location.href = URL_PLAY; } catch { /* navegador travou a saida */ }
    }
  };

  const relogio = window.setTimeout(abrirNoNavegador, 1200);
  const cancelar = () => window.clearTimeout(relogio);
  try {
    window.addEventListener('pagehide', cancelar, { once: true });
    window.addEventListener('blur', cancelar, { once: true });
    document.addEventListener('visibilitychange', cancelar, { once: true });
  } catch { /* navegador antigo: fica so o relogio */ }

  try {
    window.location.href = URL_LOJA_NATIVA;
  } catch {
    cancelar();
    abrirNoNavegador();
  }
}

/** O triangulo colorido da Google Play, em SVG -- nao e emoji, e nao e imagem
    baixada: o desenho tem que ser igual em todo aparelho. */
function GlifoPlay() {
  return (
    <svg viewBox="0 0 512 512" width={22} height={22} role="img" aria-label="Google Play">
      <path d="M47.6 22.9C42.7 27.3 40 34 40 42.6v426.8c0 8.6 2.7 15.3 7.6 19.7l1.5 1.4L288.9 258v-4L49.1 21.5l-1.5 1.4z" fill="#00d3ff" />
      <path d="M368.3 337.8 288.9 258v-4l79.5-79.8 1.8 1L464.5 230c27 15.3 27 40.5 0 55.9l-94.4 53.7-1.8-1.8z" fill="#ffce00" />
      <path d="M369.3 336 288.9 256 47.6 489.1c8.9 9.4 23.6 10.6 40.2 1.2l281.5-160" fill="#ff3d47" />
      <path d="M369.3 176 87.8 16.8C71.2 7.4 56.5 8.6 47.6 18l241.3 238L369.3 176z" fill="#00f076" />
    </svg>
  );
}

// ============================================================== AVALIAR ====
/**
 * PEDIR AVALIACAO NA PLAY.
 *
 * Nota e numero de avaliacoes sao dos sinais mais pesados no ranking de busca
 * da Play -- um app com 20 avaliacoes de 4,8 aparece na frente de um com 3.
 * Por isso isto existe; e por isso ele e cuidadoso.
 *
 * ============================================================================
 * AS TRES TRAVAS, E O MOTIVO DE CADA UMA (as mesmas do 38 Brasil)
 *
 * 1. SO DENTRO DO APP. Levar quem esta no navegador para a ficha da Play nao
 *    rende avaliacao: so quem instalou consegue avaliar.
 *
 *    ⚠️ Repare que esta trava usa `dentroDoApp()` ao CONTRARIO do botao de
 *    baixar, e as duas estao certas. Baixar erra para MOSTRAR (na duvida,
 *    oferece); avaliar erra para ESCONDER (na duvida, cala). Por isso o
 *    `dentroDoApp()` so responde sim quando tem certeza -- e por isso este
 *    pedido so vai aparecer a partir da versao do app seguinte a 1.2.0, que e
 *    a primeira que manda `?nativeApp=1`.
 *
 * 2. SO PARA QUEM JA TERMINOU UMA TEMPORADA. Pedir nota a quem acabou de
 *    entrar e o jeito mais rapido de ganhar uma estrela. O 38 pede a quem e
 *    premium; aqui a temporada fechada e o sinal melhor -- o 82 tem muito mais
 *    gente que jogou do que gente que pagou, e quem chegou ao fim de 34
 *    rodadas gostou do jogo.
 *
 * 3. DISPENSAVEL POR 14 DIAS. Quem disse "agora nao" nao pode ser perguntado
 *    de novo amanha. O prazo e por conta, guardado no proprio aparelho.
 * ============================================================================
 */
const CHAVE_DISPENSA = 'basquete82.avaliar.dispensado';
const DISPENSA_MS = 14 * 24 * 60 * 60 * 1000;

function dispensado() {
  try {
    const at = Number(localStorage.getItem(CHAVE_DISPENSA) || 0);
    return !!at && Date.now() - at < DISPENSA_MS;
  } catch { return false; }
}

function dispensar() {
  try { localStorage.setItem(CHAVE_DISPENSA, String(Date.now())); } catch { /* bloqueado */ }
}

export function AvaliarCta({ temporadasFechadas = 0 }) {
  const [fora, setFora] = React.useState(() => dispensado());

  if (!APP_NA_PLAY) return null;
  if (!dentroDoApp()) return null;
  if (temporadasFechadas < 1) return null;
  if (fora) return null;

  const avaliar = (e) => {
    marcar('avaliacao_aberta', { temporadas: temporadasFechadas });
    /* Some depois de abrir a Play: quem foi avaliar nao precisa ver o pedido
       de novo, e nao ha como saber se a pessoa realmente avaliou. */
    dispensar();
    setFora(true);
    aoClicar(e);
  };

  return (
    <div className="avaliar">
      <div>
        <div className="avaliar-estrelas" aria-hidden="true">★★★★★</div>
        <div className="avaliar-t">
          Se o <b>82 Basquete</b> esta te entretendo, uma avaliacao na Play
          ajuda muito o jogo a aparecer para outras pessoas.
        </div>
      </div>
      <div className="avaliar-acoes">
        <button className="primary" onClick={avaliar}>Avaliar na Play</button>
        <button
          className="ghost"
          onClick={() => { marcar('avaliacao_dispensada'); dispensar(); setFora(true); }}
        >
          agora nao
        </button>
      </div>
    </div>
  );
}

export function PlayStoreCta({ className = '' }) {
  if (!APP_NA_PLAY) return null;
  if (dentroDoApp()) return null;

  return (
    <a
      className={`play-cta${className ? ` ${className}` : ''}`}
      href={URL_PLAY}
      target="_blank"
      rel="noopener noreferrer"
      onClick={aoClicar}
      title="Baixar o 82 Basquete na Google Play"
      aria-label="Baixar o 82 Basquete na Google Play"
    >
      <span className="play-cta-glyph" aria-hidden="true"><GlifoPlay /></span>
      <span className="play-cta-copy">
        <small>Baixe agora no</small>
        <strong>Google Play</strong>
      </span>
      <span className="play-cta-badge">Gratis</span>
      <span className="play-cta-shine" aria-hidden="true" />
    </a>
  );
}
